import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PagoPorServicioService {

  constructor(    
    private _http: HttpClient
  ) { }

  saveASociacion(data: any){
    const url = environment.URL_BASE + 'PagoXServicioAuthorization/savePagoXServicio';
    return this._http.post(url,data);
  }

  listarPagoXServicio(data: any){
    const url = environment.URL_BASE + 'PagoXServicioAuthorization/listarPagoXServicio';
    return this._http.post(url,data);
  }

  eliminarPagoXServicio(data: any){
    const url = environment.URL_BASE + "PagoXServicioAuthorization/updatePagoXServicio";
    return this._http.post(url, data);
  }

  listarPagoXServicioEmpresa(IdEmpresa: any){
    const url = environment.URL_BASE + 'PagoXServicioAuthorization/listarXEmpresa' + "?idEmpresa=" + IdEmpresa
    return this._http.get(url)
  }

}
